import { FC, PropsWithChildren } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';

type LoaderProps = {
  isLoading: boolean;
  hideBg?: boolean;
  loaderClassName?: string;
};

const LoaderOverlay: FC<PropsWithClassName<PropsWithChildren<LoaderProps>>> = ({
  className,
  isLoading = false,
  children,
  hideBg = false,
  loaderClassName,
}) => {
  return (
    <div className={cn('relative min-h-10', className)}>
      {isLoading && (
        <div
          className={cn(
            'absolute w-full h-full z-10 flex justify-center items-center cursor-wait top-0 left-0',
            {
              'bg-primary bg-opacity-5': !hideBg,
            },
            loaderClassName
          )}
        >
          <span className="loading loading-spinner loading-md"></span>
        </div>
      )}
      {children}
    </div>
  );
};

export default LoaderOverlay;
